import React from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress } from '@material-ui/core';

const LoadingButton = props => {
  const { isLoading, children, ...otherProps } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Button {...otherProps}>
      {isLoading ? <CircularProgress size={24} color="inherit" /> : children}
    </Button>
  );
};

LoadingButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.string.isRequired,
};

export default LoadingButton;
